export default __webpack_public_path__ + "static/media/advicegradissuegfx-06.52b69499.png";